import { Attribute } from 'zakeke-configurator-react';

export const formatData = (
  val: Attribute[],
): Record<string, { name: string; quantity: number }> => {
  const quoteData: Record<string, { name: string; quantity: number }> = {};

  val.forEach((attribute) => {
    const selectedOption = attribute.options.find((option) => option.selected);

    if (selectedOption) {
      const parsedCode = JSON.parse(selectedOption.code);

      // Normalization of name and id parameters (remove _JPN)
      let normalizedId = parsedCode.id;
      let normalizedName = selectedOption.name;

      if (attribute.name === 'Butt Plates' && parsedCode.id.endsWith('_JPN')) {
        normalizedId = parsedCode.id.replace('_JPN', '');
        normalizedName = selectedOption.name.replace('_JPN', '');
      }

      quoteData[normalizedId] = {
        name: normalizedName,
        quantity: 1,
      };
    }
  });

  return quoteData;
};
